(() => {
  const SELECTOR = '#MainContent > .bobgo-tracking';

  const icon = (name) => {
    const icons = {
      parcel: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="m4.5 7.5 7.5 4 7.5-4M12 11.5V20M5 7.2 12 3l7 4.2v9.6L12 21l-7-4.2V7.2Z"/></svg>',
      mail: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M4 6.5h16v11H4zM4.5 7l7.5 6 7.5-6"/></svg>',
      search: '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 4 4"/></svg>',
      route: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M6 18.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm12-8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM8.5 16h2.25a3.25 3.25 0 0 0 0-6.5H9.5a3.5 3.5 0 0 1 0-7H12"/><path d="m15.5 8 2.5 2.5L20.5 8"/></svg>',
      support: '<svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 13v-1a7 7 0 0 1 14 0v1M5 13H3.5v5H7v-5H5Zm14 0h1.5v5H17v-5h2Zm0 5c0 2-1.5 3-4 3"/></svg>'
    };
    return icons[name] || icons.parcel;
  };

  const enhance = () => {
    const tracking = document.querySelector(SELECTOR);
    if (!tracking || tracking.dataset.vcTrackingEnhanced === 'true') return false;

    const searchContainer = tracking.querySelector('#mc-search-container');
    const trackingContainer = tracking.querySelector('#mc-tracking-container');
    const input = tracking.querySelector('#mc-tracking-number');
    const button = tracking.querySelector('#mc-track-button');
    if (!searchContainer || !trackingContainer || !input || !button) return false;

    tracking.dataset.vcTrackingEnhanced = 'true';
    tracking.classList.add('vc-track-page');
    document.body.classList.add('vc-track-page--active');
    document.title = 'Track Order – Velvet Curl Beauty ZA';

    const hero = document.createElement('section');
    hero.className = 'vc-track-hero';
    hero.setAttribute('aria-labelledby', 'vc-track-title');
    hero.innerHTML = `
      <div class="vc-track-hero__glow vc-track-hero__glow--one"></div>
      <div class="vc-track-hero__glow vc-track-hero__glow--two"></div>
      <div class="vc-track-hero__inner">
        <div class="vc-track-hero__copy">
          <p class="vc-track-kicker">Order tracking</p>
          <h1 id="vc-track-title">Follow every<br>beautiful step.</h1>
          <p>From our shelf to your door, see exactly where your Velvet Curl parcel is on its journey.</p>
          <div class="vc-track-live"><span></span> Live courier updates powered by Bob Go</div>
        </div>
        <div class="vc-track-hero__art" aria-hidden="true">
          <span class="vc-track-hero__route"></span>
          <span class="vc-track-hero__pin vc-track-hero__pin--start">${icon('parcel')}</span>
          <span class="vc-track-hero__pin vc-track-hero__pin--end">✓</span>
          <span class="vc-track-hero__label vc-track-hero__label--start">Dispatched</span>
          <span class="vc-track-hero__label vc-track-hero__label--end">Your door</span>
        </div>
      </div>`;

    const card = document.createElement('section');
    card.className = 'vc-track-search-card';
    card.setAttribute('aria-labelledby', 'vc-track-search-title');
    tracking.insertBefore(hero, searchContainer);
    tracking.insertBefore(card, searchContainer);
    card.appendChild(searchContainer);

    const formContent = searchContainer.firstElementChild;
    const heading = searchContainer.querySelector('h2');
    const headingWrap = heading?.parentElement;
    if (formContent) formContent.classList.add('vc-track-search-card__form');
    if (headingWrap) headingWrap.classList.add('vc-track-search-card__heading');
    if (heading) {
      heading.id = 'vc-track-search-title';
      heading.textContent = 'Find your parcel';
    }

    if (headingWrap) {
      headingWrap.insertAdjacentHTML('beforeend', `
        <span class="vc-track-search-card__icon">${icon('search')}</span>
        <p>Enter the order number from your confirmation email or the tracking reference from your dispatch email.</p>`);
    }

    const label = document.createElement('label');
    label.className = 'vc-track-label';
    label.htmlFor = 'mc-tracking-number';
    label.textContent = 'Order or tracking number';
    input.before(label);
    input.setAttribute('aria-describedby', 'vc-track-hint');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    input.placeholder = 'e.g. 13126 or your courier reference';

    const hint = document.createElement('p');
    hint.id = 'vc-track-hint';
    hint.className = 'vc-track-hint';
    hint.textContent = 'Tip: you can use either number. Do not include spaces before or after it.';
    button.after(hint);
    button.textContent = 'Track my order';

    Array.from(formContent?.children || []).forEach((element) => {
      if (element.matches('div.clearfix') || (element.tagName === 'DIV' && !element.id && element.textContent.trim() === '')) {
        element.classList.add('vc-track-spacer');
      }
    });

    const errorContainer = tracking.querySelector('#mc-error-container');
    if (errorContainer) {
      errorContainer.setAttribute('role', 'status');
      errorContainer.setAttribute('aria-live', 'polite');
    }
    trackingContainer.setAttribute('aria-live', 'polite');

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        button.click();
      }
    });

    const guidance = document.createElement('section');
    guidance.className = 'vc-track-guidance';
    guidance.setAttribute('aria-labelledby', 'vc-track-how-title');
    guidance.innerHTML = `
      <div class="vc-track-guidance__heading">
        <p class="vc-track-kicker">Simple and transparent</p>
        <h2 id="vc-track-how-title">How tracking works</h2>
        <p>Your updates begin once your parcel has been handed to the courier.</p>
      </div>
      <div class="vc-track-steps">
        <article><span class="vc-track-step__number">01</span><span class="vc-track-step__icon">${icon('mail')}</span><h3>Find your number</h3><p>Check your order confirmation or dispatch email for your order or tracking reference.</p></article>
        <article><span class="vc-track-step__number">02</span><span class="vc-track-step__icon">${icon('search')}</span><h3>Enter and track</h3><p>Type the number above to open the latest information supplied by the courier.</p></article>
        <article><span class="vc-track-step__number">03</span><span class="vc-track-step__icon">${icon('route')}</span><h3>Follow the journey</h3><p>See collection, transit and delivery milestones together in one clear timeline.</p></article>
      </div>`;

    const support = document.createElement('aside');
    support.className = 'vc-track-support';
    support.setAttribute('aria-labelledby', 'vc-track-support-title');
    support.innerHTML = `
      <div class="vc-track-support__icon">${icon('support')}</div>
      <div>
        <p class="vc-track-kicker">Here when you need us</p>
        <h2 id="vc-track-support-title">Can’t find your parcel?</h2>
        <p>Tracking is available after dispatch. If you still need a hand, send us your order number and we’ll check it for you.</p>
      </div>
      <div class="vc-track-support__actions">
        <a href="mailto:velvetcurlbeauty.support@gmail.com?subject=Help%20tracking%20my%20Velvet%20Curl%20order">Email customer care <span>→</span></a>
        <small>Replies within 1–2 business days</small>
      </div>`;

    trackingContainer.after(guidance, support);

    document.querySelectorAll('a[href$="/a/track"]').forEach((link) => {
      if (link.closest('header') || link.closest('.menu-drawer')) {
        link.setAttribute('aria-current', 'page');
        link.classList.add('header__active-menu-item');
      }
    });
    return true;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  const observer = new MutationObserver(() => {
    if (enhance()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
})();
